"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BoxTrailerDrive = function BoxTrailerDrive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 89.93 24",
    width: "89.93",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#93c01f"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m27.46 16.16a3.9 3.9 0 0 0 -3.85 3.33h-7.95v-18a.79.79 0 0 0 -.79-.78h-7a.78.78 0 0 0 -.69.4l-3.86 7-3 3a.79.79 0 0 0 -.23.56v8.61a.78.78 0 0 0 .78.78h3.28a3.89 3.89 0 0 0 7.54 0h12a3.91 3.91 0 1 0 3.77-4.9zm0 6.26a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1 -2.35 2.35zm-25.89-4.49h3.08a3.82 3.82 0 0 0 -.58 1.56h-2.5zm12.52-1.57h-4.95a3.76 3.76 0 0 0 -1.22-.21 4 4 0 0 0 -1.25.22s0 0 0 0h-5.1v-4.37l2.9-2.9a.76.76 0 0 0 .13-.17l3.69-6.66h5.8zm-8.52 3.71a2.35 2.35 0 1 1 2.35 2.35 2.36 2.36 0 0 1 -2.35-2.35zm5.62-2.14h2.9v1.56h-2.31a3.83 3.83 0 0 0 -.59-1.56z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.7 10a.81.81 0 0 0 .3.1.79.79 0 0 0 .71-.43l2.17-4.27h1.86a.78.78 0 0 0 0-1.56h-2.35a.78.78 0 0 0 -.7.43l-2.35 4.73a.78.78 0 0 0 .36 1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m87.91 0h-67.32a.78.78 0 0 0 -.78.79v14a.78.78 0 0 0 .78.78h13.41v3.35a.79.79 0 0 0 .78.79h19.47a.79.79 0 0 0 .78-.79.78.78 0 0 0 -.78-.78h-18.65v-3.35a.79.79 0 0 0 -.79-.78h-13.44v-12.43h65.75v16.56h-5.28a.78.78 0 0 0 -.78.78.79.79 0 0 0 .78.79h6.07a.79.79 0 0 0 .78-.79v-18.12a.78.78 0 0 0 -.78-.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m68 16.16a3.91 3.91 0 1 0 3.92 3.91 3.92 3.92 0 0 0 -3.92-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.35 2.35 2.35 0 0 1 2.33 2.35z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m76.76 16.16a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm0 6.26a2.35 2.35 0 1 1 2.35-2.35 2.36 2.36 0 0 1 -2.35 2.35z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m59.21 16.16a3.91 3.91 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.35 2.36 2.36 0 0 1 2.35 2.35z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m63.42 14.29v-10.95l9.13 5.47z",
    fill: "#9ece06"
  }));
};

var _default = BoxTrailerDrive;
exports["default"] = _default;